/* eslint-disable no-shadow */
import React, { useEffect } from 'react';

import styled, { css } from 'styled-components';
import { keyframes } from 'styled-components';

import { theme, Icon } from 'fpay-ui';

const fontTypes = {
  title: css`
    ${({ theme }) => theme.textTypes['H5-w400']};
    line-height: 1.2;
    color: ${theme.colors.gray900};
  `,
  text: css`
    ${({ theme }) => theme.textTypes['Subtitle-1-w500']};
    color: ${theme.colors.gray700};
    line-height: 1.2;
  `,
  button: css`
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: normal;
  `,
};

const Layout = styled.div`
  padding-top: 50px;
  padding-bottom: 32px;
  padding-left: 40px;
  padding-right: 40px;
  height: 368px;
`;

const LayoutImage = styled.div`
  display: flex;
  justify-content: center;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Rotate = styled.div`
  display: inline-block;
  animation: ${rotate} 3s linear infinite;
`;

const Title = styled.div`
  ${fontTypes.title}
  margin-top: 25px;
  text-align: center;
`;

const Text = styled.div`
  ${fontTypes.text}
  margin-top: 16px;
  text-align: center;
`;

const LayoutButtons = styled.div`
  margin-top: 25px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Button = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    ${fontTypes.button}
    text-align: center;
    align-items: center;
    width: 120px;
    height: 40px;
    border-radius: 4px;
    background-color: ${(props) => (props.noThanks ? '#ffffff' : `${theme.colors.gbrand500}`)};
    color: ${(props) => (props.noThanks ? `${theme.colors.gbrand500}` : '#ffffff')};
    cursor: pointer;
    transition: all 0.3s ease 0s;
    &:hover {
      box-shadow: ${(props) => (props.noThanks ? '' : '0 1px 6px rgb(32 33 36 / 28%)')};
      background-color: ${(props) => (props.noThanks ? '' : `${theme.colors.gbrand600}`)};
      color: ${(props) => (props.noThanks ? `${theme.colors.gbrand600}` : '#ffffff')};
    }
    &:active {
      border: ${(props) => (props.noThanks ? '' : `1px solid ${theme.colors.gbrand500}`)};
    }
  `
);

const StyledIcon = styled(Icon)`
  position: relative;
  width: 100px;
  height: 100px;
  margin-top: 3px;
  margin-left: 1px;
`;

const ModalToRedirect = ({ text, link, handleCancel, textConfirm, textCancel }) => {
  useEffect(() => {
    const timer = setTimeout(() => window.open(link, '_blank', 'noopener'), 5000);

    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <LayoutImage>
        <Rotate>
          <StyledIcon icon="ic-loader" color="gray600" />
        </Rotate>
      </LayoutImage>
      <Title>{text}</Title>
      <Text>{textConfirm}</Text>
      <LayoutButtons>
        <Button noThanks onClick={handleCancel}>
          {textCancel}
        </Button>
      </LayoutButtons>
    </Layout>
  );
};

export default ModalToRedirect;
